import dayjs              from "dayjs";
import fromNow            from "dayjs/plugin/relativeTime";
import React              from "react";
import { useTranslation } from "react-i18next";
import { Waypoint }       from "react-waypoint";

import Icon             from "_components/atoms/icon";
import Typography       from "_components/atoms/typography";
import SearchContentBox from "_components/molecules/searchContentBox";
import useStyles        from "_styles/templates/ListWrapper";

import Ads              from "./ads";
import { SkeletonView } from "./SkeletonView";

// use fromNow from dayjs
dayjs.extend ( fromNow );

export default function ListWrapper ( {
	videosList,
	isFetching,
	from,
	customClass,
	getNextData,
	isDataDepleted,
	isFetchingData
} ) {
	const { classes } = useStyles ( undefined, { name: "styles" } );
	const dummyData   = new Array ( 3 ).fill ( 0 );
	const { t }       = useTranslation ();
	const text        = "Recommended for you";

	return (
		<div className = { classes.videoListContainer }>
			{videosList[0] && (
				<div className = { classes.titleContainer }>

					<Typography
						className = { classes.titleText }
						title = { text }
						variant = "body1"
					/>
				</div>
			)}

			{
				!isFetching && !videosList.length ? (
					<div className = { classes.emptyContainer }>
						<Icon sameInBothTheme
							className = { classes.svgIcon }
							name      = "videoDetailEmptyIcon"
						/>

						<Typography
							className = "fontBold topSpacing"
							title     = { t ( "video_right_empty" ) }
						/>
					</div>
				) : (
					<div className = { classes.listContainer }>
						{
							videosList.map ( ( item, index ) => {

								const {
									id,
									createdAt,
									title,
									userData,
									thumbnail,
									views
								} = item;

								const session = {
									thumbnail    : thumbnail,
									videoId      : id,
									createdAt,
									streamTitle  : title,
									views,
									isCeleb      : userData?.isCeleb,
									profileId    : userData?.id,
									profilePic   : userData?.photo,
									streamerName : userData?.name

								};

								return (
									<React.Fragment key = { item.id }>
										<Ads idx = { index } />

										<SearchContentBox
											disableFollowModal
											currentIndex = { index }
											customClass = { customClass }
											direction = "row"
											from = { from }
											lastIndex = { videosList.length - 1 }
											session = { session }
										/>

										{!isDataDepleted && !isFetchingData && videosList.length > 0 && index === videosList.length - 4 && (
											<Waypoint
												onEnter = { () => getNextData () }
											/>
										)}
									</React.Fragment>
								);
							} )

						}

						{isFetchingData
							? dummyData.map ( ( item, index ) => (
								<SkeletonView
									key                  = { index }
									customContainerStyle = { {
										margin: "0.8rem 0"
									} }
								/>
							) )
							: null}
					</div>
				)
			}
		</div>
	);
}
